import React, { useState, useEffect, useRef } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Text from '../../components/Text';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Card, { DefaultLoadingBodyComponent } from '../../components/Card';
import CardPoints from './CardPoints';

import api from '../../services/rewardsApi';
import { Form } from 'react-bootstrap';

export default function CheckBalance() {
  const cpfRef = useRef(null);

  const [cpf, setCpf] = useState();
  const [points, setPoints] = useState();
  const [user, setUser] = useState();
  const [showResult, setShowResult] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);

  function Header() {
    return (
      <Text color="#464E5F" type="header">
        Consultar saldo
      </Text>
    );
  }

  async function fetchBalance() {
    if (cpf) {
      setLoadingCard(true);
      try {
        const { data } = await api.get(`points/${cpf.replace(/[^0-9]/g, '')}`);
        setPoints(data.points ?? 0);
        setUser(data.user);
        setShowResult(true);
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingCard(false);
      }
      setLoadingCard(false);
    }
  }

  useEffect(() => {
    fetchBalance();
  }, []);

  function handleChangeCpf(value) {
    setCpf(value);
    setShowResult(false);
  }

  useEffect(() => {
    if (cpfRef?.current) {
      cpfRef.current?.inputElement?.focus();
    }
  }, [cpfRef]);

  async function handleSubmit(e) {
    e.preventDefault();
    fetchBalance();
  }

  return (
    <Row>
      <Col xs={12}>
        <Card
          loading={loadingCard}
          LoadingBodyComponent={() => (
            <DefaultLoadingBodyComponent linesCount={1} perLine={1} />
          )}
          header={<Header />}
        >
          <Form onSubmit={e => handleSubmit(e)}>
            <Row className="d-flex justify-content-around align-items-center">
              <Col xs={6}>
                <Col xs={12}>
                  <Row>
                    <Col xs={8}>
                      <Input
                        label="CPF *"
                        value={cpf}
                        onChange={event => handleChangeCpf(event.target.value)}
                        masked
                        ref={cpfRef}
                        mask={[
                          /[0-9]/,
                          /[0-9]/,
                          /[0-9]/,
                          '.',
                          /[0-9]/,
                          /[0-9]/,
                          /[0-9]/,
                          '.',
                          /[0-9]/,
                          /[0-9]/,
                          /[0-9]/,
                          '-',
                          /[0-9]/,
                          /[0-9]/,
                        ]}
                      />
                    </Col>

                    <Col className="mt-2">
                      <Button onClick={() => fetchBalance()} className="mt-4">
                        <Text clickable>Consultar</Text>
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Col>
              <Col xs={4}>
                {showResult && (
                  <>
                    <CardPoints user={user} points={points} />
                  </>
                )}
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
